
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import VisionHero from './components/VisionHero';
import VisionMission from './components/VisionMission';
import VisionValues from './components/VisionValues';
import VisionFuture from './components/VisionFuture';

export default function Vision() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <VisionHero />
        <VisionMission />
        <VisionValues />
        <VisionFuture />
      </main>
      <Footer />
    </div>
  );
}
